<!--
    描述：模板设置 --- 字段维护
    时间：2020-11-21
    Created by ws
-->
<template>
	<div class="operation-layout">
		<div class="operation-main">
			<div class="operation-header">
				<el-button size="small"
						   class="btn-blue pdl20"
						   icon="el-icon-plus"
						   @click="addTemplate"
						   v-if="roleBtns.includes('addField')">添加字段</el-button>
			</div>
			<!-- 表格内容 -->
			<div class="operation-container w-table-layout w-table-page">
				<div class="w-table-content">
					<vxe-table :data="tableData"
							   border
							   resizable
							   height="100%"
							   size="small"
							   highlight-current-row
							   highlight-hover-row
							   show-overflow="tooltip"
							   show-header-overflow="tooltip"
							   :loading="loading">
						<vxe-table-column type="seq"
										  title="序号"
										  width="60"
										  align="center"></vxe-table-column>
						<vxe-table-column field="fieldName"
										  title="字段名称"
										  show-overflow
										  min-width="150"
										  header-align="center"></vxe-table-column>
						<vxe-table-column field="fieldAlias"
										  title="业务字段名称（英文）"
										  min-width="150"
										  header-align="center"></vxe-table-column>
						<vxe-table-column field="applySysName"
										  title="业务系统"
										  show-overflow
										  min-width="150"
										  align="center"></vxe-table-column>
						<vxe-table-column field="applyTypeName"
										  title="关联类型"
										  show-overflow
										  min-width="400"
										  header-align="center"></vxe-table-column>
						<vxe-table-column title="操作"
										  width="160"
										  align="center">
							<template v-slot="{ row }">
								<el-button type="success"
										   size="small"
										   round
										   plain
										   class="table-btn"
										   @click="doEdit(row)"
										   v-if="roleBtns.includes('edit')">
									<svg-icon icon-class="form-edit"></svg-icon> 编辑
								</el-button>
								<!-- <span class="btn-separator"> | </span> -->
								<el-button type="danger"
										   size="samll"
										   class="table-btn"
										   round
										   plain
										   icon="el-icon-delete"
										   @click="doDelete(row.id)"
										   v-if="roleBtns.includes('delete')">删除</el-button>
							</template>
						</vxe-table-column>
					</vxe-table>
				</div>
				<div class="w-table-footer">
					<vxe-pager size="mini"
							   :current-page="currentPage"
							   :page-size="pageSize"
							   :total="totalResult"
							   class="text-center"
							   :page-sizes="[10, 20, 50, 100, { label: '全部数据', value: -1 }]"
							   :layouts="[
                            'Total',
                            'Sizes',
                            'PrevPage',
                            'JumpNumber',
                            'NextPage',
                        ]"
							   @page-change="handlePageChange">
					</vxe-pager>
				</div>
			</div>
		</div>

		<!-- 新增协议模板弹窗 -->
		<el-dialog :visible.sync="dialogObj.visible"
				   :width="dialogObj.width"
				   :title="dialogObj.title"
				   top="10vh"
				   center
				   :close-on-click-modal="false"
				   @closed="handleClosed">
			<el-form ref="fieldForm"
					 :model="fieldForm"
					 :rules="fieldRules"
					 v-if="dialogObj.visible"
					 label-width="170px"
					 :show-message="false">
				<el-form-item label="字段名称："
							  prop="fieldName">
					<el-input v-model="fieldForm.fieldName"
							  placeholder="请输入..."></el-input>
				</el-form-item>
				<el-form-item label="业务字段名称(英文)："
							  prop="fieldAlias">
					<el-input v-model="fieldForm.fieldAlias"
							  placeholder="请输入业务字段名称(英文)..."></el-input>
				</el-form-item>
				<el-form-item label="业务系统："
							  prop="applySys">
					<el-select v-model="fieldForm.applySys"
							   placeholder="请选择"
							   clearable>
						<el-option v-for="(item, index) in ywxt"
								   :key="'系统' + index"
								   :value="item.value"
								   :label="item.sname"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="关联类型："
							  prop="applyTypeList">
					<el-checkbox-group v-model="fieldForm.applyTypeList"
									   v-if="typeList.length > 0">
						<el-checkbox v-for="(item, index) in typeList"
									 :key="`类型${index}`"
									 :label="item.value">{{ item.sname }}</el-checkbox>
					</el-checkbox-group>
					<div v-else>暂无数据</div>
				</el-form-item>
			</el-form>

			<!-- footer 组件 -->
			<div slot="footer"
				 class="dialog-footer text-center">
				<el-button size="small"
						   class="btn"
						   @click="dialogObj.visible = false">取 消</el-button>
				<el-button type="primary"
						   size="small"
						   class="btn btn-blue"
						   :loading="dialogObj.btnLoading"
						   @click="doSave">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import {
	getAllFields,
	saveFields,
	deleteFields,
} from 'api/modules/field_management'
import { getDictByParentValue } from 'api/modules/dict'
import { mapState } from 'vuex'
export default {
	data() {
		return {
			tableData: [],
			currentPage: 1,
			pageSize: 10,
			totalResult: 0,
			loading: false,
			dialogObj: {
				visible: false,
				title: '新增协议模板',
				width: '600px',
				mode: 'add',
				btnLoading: false,
			},
			currentRow: {},
			fieldForm: {
				fieldName: '', // 字段名称
				fieldAlias: '', // 英文名称
				applySys: '', // 应用业务
				applyType: '', // 应用类型
				applyTypeList: [], // 前台 数组数据类型
			},
			fieldRules: {
				fieldName: [{ required: true, trigger: 'blur' }],
				fieldAlias: [{ required: true, trigger: 'blur' }],
				applySys: [{ required: true, trigger: 'change' }],
				applyTypeList: [
					{ required: true, trigger: 'change', type: 'array' },
				],
			},
			typeList: [], // 根据业务系统返回的 应用类型数组
		}
	},
	created() {
		this.doSearch()
	},
	methods: {
		// 获取table 数据
		doSearch() {
			this.tableData = []
			this.loading = true
			let params = {
				current: this.currentPage,
				size: this.pageSize,
			}
			getAllFields(params)
				.then((res) => {
					this.loading = false
					// console.log(res)
					if (res.code === 0) {
						this.totalResult = parseInt(res.data.total)
						this.tableData = res.data.records
					}
				})
				.catch((err) => {
					this.loading = false
				})
		},

		// 切换页码
		handlePageChange({ currentPage, pageSize }) {
			this.currentPage = currentPage
			this.pageSize = pageSize

			this.doSearch()
		},

		// 切换业务系统
		handleChange(value) {
			// this.fieldForm.applyType = ''
			this.typeList = []
			let that = this

			if (value) {
				getDictByParentValue({ value: value }).then((res) => {
					if (res.operationCode === 1) {
						this.typeList = res.data
					}
				})
			}
		},

		// 点击新增协议模板
		addTemplate() {
			this.dialogObj.visible = true
			this.dialogObj.title = '新增模板字段'
			this.dialogObj.mode = 'add'
		},

		// 点击编辑
		doEdit(row) {
			row.applyTypeList = []
			this.fieldForm = Object.assign({}, row)
			this.fieldForm.applyTypeList = row.applyType.split(',')

			this.dialogObj.visible = true
			this.dialogObj.title = '编辑模板字段'
			this.dialogObj.mode = 'edit'
		},

		// 点击删除
		doDelete(id) {
			this.$confirm('确认删除该字段吗?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			})
				.then(() => {
					deleteFields({ id: id })
						.then((res) => {
							this.$message.success('删除成功！')
							this.doSearch()
						})
						.catch((err) => {})
				})
				.catch(() => {})
		},

		// 点击保存模板
		doSave() {
			this.dialogObj.btnLoading = true
			let params = Object.assign({}, this.fieldForm)
			this.$refs.fieldForm.validate((valid) => {
				if (valid) {
					saveFields(params)
						.then((res) => {
							if (res.code === 0) {
								this.$message.success('保存成功！')
								this.dialogObj.visible = false
								this.dialogObj.btnLoading = false
								this.doSearch()
							} else {
								setTimeout(() => {
									this.dialogObj.btnLoading = false
								}, 2000)
							}
						})
						.catch((err) => {
							setTimeout(() => {
								this.dialogObj.btnLoading = false
							}, 2000)
						})
				} else {
					setTimeout(() => {
						this.dialogObj.btnLoading = false
					}, 2000)
					this.$message.warning('请完善必填项')
				}
			})
		},

		// 弹窗关闭 清空表单
		handleClosed() {
			this.fieldForm = {
				fieldName: '', // 字段名称
				fieldAlias: '', // 英文名称
				applySys: '', // 应用业务
				applyType: '', // 应用类型
				applyTypeList: [], // 前台 数组数据类型
			}
		},
	},
	computed: {
		...mapState('dict', {
			ywxt: (state) => state.projectDict.mbywxt, // 业务系统
		}),
		...mapState('menu', {
			roleBtns: (state) => state.roleBtns,
		}),
	},
	watch: {
		// 监听业务系统变化
		'fieldForm.applySys': {
			handler: function (val) {
				this.handleChange(val)
			},
			deep: true,
		},

		// 监听 applyTypeList
		'fieldForm.applyTypeList': {
			handler: function (arr) {
				if (arr.length > 0) {
					this.fieldForm.applyType = arr.join(',')
				} else {
					this.fieldForm.applyType = ''
				}
			},
			deep: true,
		},
	},
}
</script>

<style scoped lang="less"></style>
